import { useQuery } from '@tanstack/react-query';
import telemetryApi from '../../services/telemetryApi';

export const telemetryKeys = {
  all: ['telemetry'] as const,
  hourly: (orgId: string, deviceId: string, from: string, to: string) =>
    ['telemetry', 'hourly', orgId, deviceId, from, to] as const,
  latest: (deviceId: string) => ['telemetry', 'latest', deviceId] as const,
};

export function useTelemetryHourly(orgId?: string, deviceId?: string, from?: string, to?: string) {
  return useQuery({
    queryKey: telemetryKeys.hourly(orgId!, deviceId!, from!, to!),
    queryFn: () => telemetryApi.getHourly(orgId!, deviceId!, from!, to!),
    enabled: !!orgId && !!deviceId && !!from && !!to,
    staleTime: 30_000,
  });
}

export function useTelemetryLatest(orgId?: string, deviceId?: string) {
  return useQuery({
    queryKey: telemetryKeys.latest(deviceId!),
    queryFn: () => telemetryApi.getLatest(orgId!, deviceId!),
    enabled: !!orgId && !!deviceId,
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
}
